import type { Config } from 'tailwindcss';

import { animation, keyframes } from './tokens/animations';
import { borderColor, surfaceColors, textColor } from './tokens/colors';
import { extendBackdropBlur, shadows } from './tokens/effects';
import { fontFamily, fontSize, fontWeight } from './tokens/fonts';
import {
  borderRadius,
  borderWidth,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  spacing,
} from './tokens/spacing';

export const theme: Config['theme'] = {
  boxShadow: shadows,
  fontFamily,
  fontSize,
  fontWeight,
  textColor: {
    c: textColor,
  },
  borderColor: {
    c: borderColor,
  },
  colors: surfaceColors,
  borderRadius,
  borderWidth,
  spacing,
  extend: {
    backdropBlur: extendBackdropBlur,
    animation,
    keyframes,
    maxHeight,
    minHeight,
    maxWidth,
    minWidth,
  },
};
